import useBreakpoints from '@thebiltheory/usebreakpoints';

const useBreakPointValue = (props: [any, any?, any?, any?]) => {
  const [value] = useBreakpoints(props, [480, 768, 992, 1280]);
  if (!value) {
    for (let i = 3; i >= 0; i--) {
      if (props[i]) return props[i];
    }
  }
  return value;
};

export default useBreakPointValue;
